const CurrencyInput = ({ value, onChange }) => {
  const handleChange = (e) => {
    const onlyNumbers = e.target.value.replace(/\D/g, "");
    onChange(onlyNumbers);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      className="w-full border rounded-lg p-3"
      value={value || ""}
      onChange={handleChange}
      placeholder="Enter amount"
    />
  );
};

export default CurrencyInput;

